import { useState, useCallback } from 'react';
import {
  // Button, Typography,
  Box,
  IconButton,
} from '@mui/material';

import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOffAltOutlinedIcon from '@mui/icons-material/ThumbUpOffAltOutlined';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbDownOffAltOutlinedIcon from '@mui/icons-material/ThumbDownOffAltOutlined';
import SourceIcon from '@mui/icons-material/Source';
import ChatFeedbackDialog from './ChatFeedbackDialog';
import type { ChatItem, ChatItemUpdateRequest } from '@/types/apiTypes';
import type { EntityId } from '@/types';

interface ChatResponseToolbarProps {
  line: ChatItem;
  updateChatLine: (id: EntityId, data: ChatItemUpdateRequest) => Promise<void>;
  showSources: boolean;
  onToggleSources: () => void;
}

function ChatResponseToolbar({
  line,
  updateChatLine,
  showSources,
  onToggleSources,
}: ChatResponseToolbarProps) {
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  const handleThumbsUp = useCallback(async () => {
    await updateChatLine(line.entity_id, { rating: true });
  }, [line.entity_id, updateChatLine]);

  const handleThumbsDown = useCallback(async () => {
    updateChatLine(line.entity_id, { rating: false })
      .then()
      .catch((error) => console.log(error));
    setFeedbackOpen(true);
  }, [line.entity_id, updateChatLine]);

  if (!line.entity_id) {
    return <></>;
  }
  return (
    <Box sx={{ alignContent: 'center' }}>
      {/* <Button variant='secondary'>
        <Typography variant='caption'>View Sources</Typography>
      </Button> */}
      <IconButton
        disabled={line.rating === true}
        onClick={line.rating !== true ? handleThumbsUp : undefined}
      >
        {line.rating === true ? (
          <ThumbUpIcon fontSize='small' color='primary' />
        ) : (
          <ThumbUpOffAltOutlinedIcon fontSize='small' />
        )}
      </IconButton>
      <IconButton
        disabled={line.rating === false}
        onClick={line.rating !== false ? handleThumbsDown : undefined}
      >
        {line.rating === false ? (
          <ThumbDownIcon fontSize='small' color='primary' />
        ) : (
          <ThumbDownOffAltOutlinedIcon fontSize='small' />
        )}
      </IconButton>
      {line.sources && (
        <IconButton
          onClick={onToggleSources}
          color={showSources ? 'primary' : 'default'}
        >
          <SourceIcon fontSize='small' />
        </IconButton>
      )}
      {feedbackOpen ? (
        <ChatFeedbackDialog
          open={feedbackOpen}
          handleClose={() => setFeedbackOpen(false)}
          line={line}
          updateChatLine={updateChatLine}
        />
      ) : undefined}
    </Box>
  );
}

export default ChatResponseToolbar;

